import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faqsSubcategory } from '../../../../core/interfaces/subCategory';
import { BreadcrumbService } from 'src/app/core/services/breadcrumb/breadcrumb.service';
import { FaqsDataLayer } from 'src/app/shared/models/seo/faqsDataLayer';
import { NavigatorService } from 'src/app/shared/services/navigator/navigator.service';
import { SeoService } from 'src/app/shared/services/seo-service/seo.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, switchMap, takeUntil } from 'rxjs';

@Component({
  selector: 'app-subCategory',
  templateUrl: './subCategory.component.html',
})
export class SubCategoryComponent implements OnDestroy {
  faqsSubcategory!: faqsSubcategory;
  equisLoadingSize: any = 'large';
  isSearchDisabled!: boolean;
  private destroyed$ = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private faqsDataLayer: FaqsDataLayer,
    private navigatorService: NavigatorService,
    private seoService: SeoService,
    private translateService: TranslateService,
  ) {
    this.activatedRoute.data
      .pipe(
        switchMap(data => {
          this.faqsSubcategory = data['faqsSubcategory'];
          this.breadcrumbService.setBreadcrumb({
            parentId: this.faqsSubcategory?.parentId,
            name: this.faqsSubcategory?.breadcrumb,
            type: this.faqsSubcategory?.__typename,
            id: this.faqsSubcategory?.sys.id,
          });
          this.setDatalayerValues(data['faqsSubcategory']);
          this.navigatorService.setDynamicTitle(
            this.faqsSubcategory.breadcrumb,
          );
          const topic = this.seoService.normalizeContentfulTitle(
            this.faqsSubcategory.title,
          );
          return this.translateService.get('SEO.META.DESCRIPTION.TOPIC', {
            topic,
          });
        }),
        takeUntil(this.destroyed$),
      )
      .subscribe(metaDescription =>
        this.seoService.updateDescriptionMetaTag(metaDescription),
      );
    this.isSearchDisabled = this.navigatorService.isSearchDisabled;
  }

  private setDatalayerValues(data: any): void {
    this.faqsDataLayer.setData(data.breadcrumb, data.publicPrivateModel);

    data.faqsSubCategoryCollection.items.forEach((item: any) => {
      this.faqsDataLayer.setSubElement(
        item.breadcrumb,
        item.publicPrivateModel,
      );
    });
    this.faqsDataLayer.saveData(window);
  }

  buildUrl(parent: any, subCategory: any): string {
    subCategory.parentName = parent.breadcrumb;
    subCategory.previousName =
      parent?.linkedFrom?.entryCollection?.items.length > 0
        ? parent.linkedFrom.entryCollection.items[0].breadcrumb
        : '';
    if (subCategory.faqsQuestionList) {
      return `preguntas/${subCategory.faqsQuestionList.breadcrumb}/${subCategory.parentName}/${subCategory.previousName}`;
    } else if (subCategory.parentName) {
      return `subcategoria/${subCategory.breadcrumb}/${subCategory.parentName}/${subCategory.previousName}`;
    }
    throw new Error('Does not match any url');
  }

  subCategoryClicked(event: any): void {
    const { parent, item } = event;
    this.router.navigate([this.buildUrl(parent, item)], {
      queryParamsHandling: 'preserve',
    });
  }

  ngOnDestroy(): void {
    this.destroyed$?.next();
    this.destroyed$?.complete();
  }
}
